import { TmApiClientError } from '@/core/error/transport/tmApiClientError'

export class TmApiBandwidthNotEnoughPermissionError extends TmApiClientError {
  public name = 'TmApiBandwidthNotEnoughPermissionError'

  public shouldBeMonitored(): boolean {
    return false
  }
}
